import { useTranslation } from "react-i18next";
import DefectStatusIcon from "components/Elements/DefectStatusIcon";

const DefectIndicator = () => {
	const { t } = useTranslation();
	return (
		<DefectStatusIcon
			label={t("label.hasEntity", { entity: t("entity.defect") })}
			tooltip={t("message.serviceHasDefect")}
		/>
	);
};

export default DefectIndicator;
